import { createContext } from 'react';
import { ThemeStateType, ThemeVariantsType } from './types';

const defaultThemeState: ThemeStateType = {
  theme: 'light',
  changeTheme: (theme: ThemeVariantsType) => {},
};

export const ThemeContext = createContext(defaultThemeState);
